import React from 'react';

const NotFound = () => {
    return (
        <div className='container'>
            <h1 className='text-center'>Page Not Found</h1>
        </div>
    );
};

export default NotFound;